import { Controller } from "@hotwired/stimulus"

// Leniwe dogrywanie opcji długiego selecta (np. lista krajów albo stref czasowych
// na /account/settings). Select renderuje się tylko z aktualną wartością (plus opcją
// pustą), a pełna lista dogrywana jest z urlValue przy pierwszej interakcji z polem
// (najechanie / focus / dotknięcie - zanim przeglądarka otworzy listę).
// Endpoint zwraca JSON: { options: [[label, value], ...] }.
// Dokumentacja i zasady użycia: docs/llm/components/lazy_select.md
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.load = this.load.bind(this)
    this.element.addEventListener("pointerenter", this.load, { once: false })
    this.element.addEventListener("focusin", this.load, { once: false })
    this.element.addEventListener("touchstart", this.load, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener("pointerenter", this.load)
    this.element.removeEventListener("focusin", this.load)
    this.element.removeEventListener("touchstart", this.load)
  }

  async load() {
    if (this.loading || this.loaded) return
    this.loading = true

    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      if (!response.ok) return

      const data = await response.json()
      this.appendOptions(data.options || [])
      this.loaded = true
    } catch {
      // brak sieci / błąd serwera - select zostaje z aktualną wartością, spróbujemy przy kolejnej interakcji
    } finally {
      this.loading = false
    }
  }

  // Dokłada opcje do selecta pomijając wartości już wyrenderowane
  // (opcję pustą i aktualnie wybraną), zachowując bieżący wybór
  appendOptions(options) {
    const current = this.element.value
    const existing = new Set([...this.element.options].map((option) => option.value))

    for (const [label, value] of options) {
      if (existing.has(value)) continue

      const option = document.createElement("option")
      option.textContent = label
      option.value = value
      this.element.add(option)
    }

    this.element.value = current
  }
}
